import React from 'react';

export const Navbar = ({ parent }) => {

    return (
    <nav className="navbar navbar-dark navbar-expand px-2 px-lg-1">
        <button data-toggle="collapse" data-target=".sidebar-collapse" className="navbar-brand p-0 btn btn-link" title="Toggle sidebar">
            <span className="h4 align-middle mb-0"><span className="lnr lnr-menu"></span></span>
        </button>
        <button className="btn btn-link navbar-brand p-0" type="button" title="Home" data-toggle="dropdown">Forque React</button>
        <div className="dropdown-menu text-uppercase mt-n1 animate-grow-in">
            <a className="dropdown-item px-3" href="../" target="_new">Home</a>
            <a className="dropdown-item px-3" href="../static" target="_new">jQuery version</a>
            <a className="dropdown-item px-3 active" href="../react" target="_new">React version</a>
            <a className="dropdown-item px-3" href="../vue" target="_new">Vue version</a>
        </div>
        <ul className="navbar-nav ml-auto">
            <li className="nav-item dropdown">
                <button className="nav-link btn btn-link p-0 text-truncate" data-toggle="dropdown">
                    <span className="align-middle" data-toggle="tooltip" data-placement="left" title="You are logged in as Robojo">
                        Robojo
                    </span>
                    <img alt="avatar" src="./assets/m20.jpg" className="avatar m-1 ml-0 rounded-circle bg-white shadow-sm" />
                </button>
                <div className="dropdown-menu dropdown-menu-right animate-grow-in text-uppercase mt-1" aria-labelledby="dropdownMenu1">
                    <a className="dropdown-item px-3" href="#profile" onClick={() => parent.showProfile()}><span className="lnr lnr-user"></span> Profile</a>
                    <a className="dropdown-item px-3" href="./inbox">
                        <span className="lnr lnr-inbox"></span> Inbox <span className="badge badge-primary badge-pill font-weight-light align-middle mb-1 p-1" title="notify count">3</span>
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item px-3" href="#modalLogout" data-target="#modalLogout" data-toggle="modal"><span className="lnr lnr-exit"></span> Logout</a>
                    <a className="dropdown-item px-3" href="http://themes.guide" target="_new" rel="nofollow">Themes.guide</a>
                    <button className="dropdown-item btn btn-link px-3 font-weight-bold text-uppercase" type="button" data-target="#modalAbout" data-toggle="modal">About</button>
                </div>
            </li>
        </ul>
    </nav>
    );
    
};

export default Navbar;
